
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import { getFormState, parseSavedData } from '../../../helpers/form';
import {
    getUsers,
    getEntities,
    getRoles,
    getMyState,
  } from "../../../state/user/actions";
import dayjs from 'dayjs';

const API_HOST = CONFIG.modules['accounts'].host



const items = {
    'Designations': {
        name: 'Designations',
        view: ''
    },
    'Departments': {
        name: 'Departments'
    },
    'Districts': {
        name: 'Districts'
    },
    'Languages': {
        name: 'Languages'
    },
    // 'TaskTypes': {
    //     name: 'TaskTypes'
    // },
    'Shifts': {
        name: 'Shifts'
    },
    // 'Campaigns': {
    //     name: 'Campaigns'
    // },
    'Hierarchies': {
        name: 'Hierarchies'
    },
    'LeaveType': {
        name: 'LeaveType'
    },
    'Query': {
        name: 'Query'
    },
    'SubQuery': {
        name: 'SubQuery'
    },
    'UnassignReasons': {
        name: 'UnassignReasons'
    }
}

const dateColumns = [
    { id: 'createdAt', label: 'Created At', minWidth: 60, format:(data, row)  => {
        return data? dayjs(data).format('DD-MM-YYYY hh:mm:ss'):''
    }},
    { id: 'updatedAt', label: 'Updated At', minWidth: 60, format:(data, row)  => {
        return data? dayjs(data).format('DD-MM-YYYY hh:mm:ss'):''} }
]

const common = [
    { id: 'name', label: 'Name', minWidth: 170 },
    ...dateColumns
]

const columnsMap = {
    'Designations': common,
    'Query': common,
    'UnassignReasons':common,
    'SubQuery': [
        { id: 'name', label: 'Name', minWidth: 80 },
        { id: 'query', label: 'Query', minWidth: 170, format: (data, row, i,map) => {
            const m = map.Query
            return data&&m[data]?m[data].name:''
        } },
        ...dateColumns
    ],
    'LeaveType':[ { id: 'name', label: 'Name', minWidth: 170 },
    { id: 'number', label: 'Max. leave', minWidth: 170 },
    { id: 'atATime', label: 'Max. leave at a time', minWidth: 170 },
    { id: 'carryForward', label: 'Carry Forward', minWidth: 170, format: (data,row)=> {
        return data?'Yes':'No'
    } },
    {
        id: 'workable',
        label: 'Workable',
        minWidth: 170,
        format: (data, row) => {
            return data ? 'Yes' : 'No'
        }
    },
    ...dateColumns],
    'Departments': [
        { id: 'name', label: 'Name', minWidth: 170 },
        { id: 'type', label: 'Type', minWidth: 170 },
        ...dateColumns
    ],
    'Districts':[
        { id: 'name', label: 'Name', minWidth: 80 },
        { id: 'code', label: 'Code', minWidth: 40 },
        { id: 'languages', label: 'Languages', minWidth: 170, format: (data, row, i,map) => {
            const m = map.Languages
            return (data || []).map(d => (m&&m[d]?m[d].name:d)).join(",")
        } },
        { id: 'secondaryLanguages', label: 'Secondary Languages', minWidth: 170, format: (data, row, i,map) => {
            const m = map.Languages
            return (data || []).map(d => (m&&m[d]?m[d].name:d)).join(",")
        } },
        ...dateColumns
    ],
    'Languages': common,
    'Campaigns': common,
    'TaskTypes': common,
    'Hierarchies':[
        { id: 'name', label: 'Name', minWidth: 80 },
        { id: 'designations', label: 'Designations', minWidth: 170, format: (data, row, i, map) => {
            const m = map.Designations
            return (data || []).map(d => (m&&m[d]?m[d].name:d)).join(",")
        } },
        ...dateColumns
    ],
    'Shifts': [
        { id: 'name', label: 'Name', minWidth: 170 },
        { id: 'start', label: 'Start Time', minWidth: 170, format:(data, row)=> {
            return data?dayjs(data).format('hh:mm:A'):''
        } },
        { id: 'end', label: 'End Time', minWidth: 170, format:(data, row)=> {
            return data?dayjs(data).format('hh:mm:A'):''
        }  },
        ...dateColumns
    ]
}

const fieldsMap = {
    'Campaigns': 
    [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
        {
            type: 'select',
            label: 'Hierarchy',
            option: { key: 'Hierarchies', value: '_id', label: 'name' },
            required: true,
            name: 'hierarchy',
        },
    ],
    'TaskTypes': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
    ],
    'Shifts': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
        {
            type: 'group',
            items: [
                {
                    type: 'time',
                    label: 'Start Time',
                    required: true,
                    name: 'start',
                    defaultValue: dayjs(),
                    parse: (d) => dayjs(d)
                },
                {
                    type: 'time',
                    label: 'End Time',
                    required: true,
                    name: 'end',
                    defaultValue: dayjs(),
                    parse: (d) => dayjs(d)
                },
            ]
        },
    ],
    'Designations': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
    ],
    'Query': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
    ],
    'UnassignReasons': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
    ],
    
    'SubQuery': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
        {
            type: 'select',
            label: 'Query',
            option: { key: 'Query', value: '_id', label: 'name' },
            required: true,
            name: 'query',
        },
    ],
    'Departments': [
        {
            type: 'select',
            label: 'Select Department Type',
            option: { key: 'department_types', value: '_id', label: 'name' },
            required: true,
            name: 'type',
        },
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
    ],
    'LeaveType': [
        
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
        {
            type: 'select',
            label: 'Workable',
            option: { key: 'leavetype_workables', value: '_id', label: 'name' },
            required: true,
            name: 'workable',
        },
        {
            type: 'number',
            label: 'No.',
            required: true,
            name: 'number'
        },
        {
            type: 'number',
            label: 'Max at a time',
            required: true,
            name: 'atATime'
        },
        {
            type: "switch",
            label: "Carry forward",
            name: "carryForward",
            defaultValue: false,
        },
    ],
    'Districts': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
        {
            type: 'text',
            label: 'Code',
            required: true,
            name: 'code'
        },
        {
            type: 'select',
            label: 'Languages',
            option: { key: 'Languages', value: '_id', label: 'name' },
            required: true,
            multiple: true,
            name: 'languages',
        },
        {
            type: 'select',
            label: 'Secondary Languages',
            option: { key: 'Languages', value: '_id', label: 'name' },
            required: true,
            multiple: true,
            name: 'secondaryLanguages',
        },
        

    ],
    'Languages': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
    ],
    'Hierarchies': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
        {
            type: 'select',
            label: 'Designations',
            option: { key: 'Designations', value: '_id', label: 'name' },
            required: true,
            multiple: true,
            name: 'designations',
        },
        {
            type: 'fields',
            name: 'reportings',
            label: 'Reportings',
            multiple: true,
            items: [
                {
                    type: 'group',
                    betweenText: 'Reports',
                    items: [
                        {
                            type: 'select',
                            label: 'Designation',
                            option: { key: 'Designations', value: '_id', label: 'name', fromValue: true },
                            required: true,
                            name: 'designation',
                        },
                        {
                            type: 'select',
                            label: 'Reports To',
                            option: { key: 'Designations', value: '_id', label: 'name', fromValue: true },
                            required: true,
                            multiple: true,
                            name: 'to',
                        },
                    ],
                }
            ]
        }
    ]
}





export const Entities = (props) => {

    const { roles, user, users, Designations, Departments, Languages, Districts, Priviledges, Hierarchies, map, Query } = useSelector((state) => (state.user || {}))
    const [active, setActive] = useState('Designations')
    const [data, setData] = useState([])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [formData, setFormData] = useState(getFormState(fieldsMap[active]))
    const dispatch = useDispatch();


    useEffect(() => {
        setData([])
        axios.get(API_HOST + '/entity?entityName=' + active).then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }, [active])

    const handleSubmit = () => {
        axios.post(API_HOST + '/entity', {
            entityName: active,
            payload: formData
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                setData([resp.data.data, ...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleEdit = () => {
        const payload = { ...formData }

        axios.put(API_HOST + '/entity', {
            entityName: active,
            payload,
            id: saved._id
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                data[index] = resp.data.data
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleDelete = () => {
        axios.delete(API_HOST + '/entity?entityName=' + active + '&ids=' + saved._id).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpenConfirm(false)
                data.splice(index, 1)
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(()=> {
        dispatch(getEntities(active));
    },[data])


    return (
        <>

            <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} />
            <ToolBar name={active} buttons={[
                {
                    name: 'Add new',
                    onClick: () => {
                        setAction('new')
                        setFormData(getFormState(fieldsMap[active]))
                        setOpen(true)
                    }
                }
            ]} />
            <Box sx={{ mt: 2 }}>
                <Grid data={data} columns={columnsMap[active]}
                    map={map}
                    actions={[
                        {
                            name: 'Edit',
                            onClick: (id) => {
                                setIndex(id)
                                setAction('edit')
                                setOpen(true)
                                const newData = { ...data[id]}
                                const parsedData = { ...(parseSavedData(newData, fieldsMap[active])) }
                                setFormData(parsedData)
                                setSaved(data[id])
                            }
                        },
                        {
                            name: 'Delete',
                            // hide: true,
                            onClick: (id) => {
                                setIndex(id)
                                setSaved(data[id])
                                setOpenConfirm(true)
                            }
                        }
                    ]}></Grid>
            </Box>
            <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={`${action == 'new' ? 'Add' : 'Edit'} ${active}`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                    {
                        name: action == 'new' ? 'Create' : 'Save',
                        onClick: () => {
                            switch (action) {
                                case 'new':
                                    handleSubmit()
                                    break;
                                case 'edit':
                                    handleEdit()
                                    break;
                                default: break;
                            }
                        }
                    }
                ]}

            >
                {
                    action == 'edit' &&
                    <Typography variant='p' color="grey">{
                        'ID: ' + saved._id
                    }</Typography>
                }
                {
                    Array.isArray(fieldsMap[active]) &&
                    <Box sx={{mt:2}}>
                    <FormA fields={fieldsMap[active]}
                        data={{ roles, Designations, Districts, Languages, Departments, users, Hierarchies, Query, department_types: [
                            {
                                _id: 'Core',
                                name: 'Core'
                            },
                            {
                                _id: 'Project Based',
                                name: 'Project Based'
                            },
                            {
                                _id:'Internal Team',
                                name: 'Internal Team'
                            }
                            
                        ],
                        leavetype_workables: [
                            {
                                _id: true,
                                name: 'Yes'
                            },
                            {
                                _id: false,
                                name: 'No'
                            }
                        ]
                    }}
                        
                        onChange={(name, value, multiple) => {
                            formData[name] = value
                            setFormData({ ...formData })
                        }}
                        state={formData || {}}
                    />
                    </Box>
                }
            </Modal>

            <Modal open={openConfirm}
                handleClose={() => { setOpen(false) }}
                head={`${'Delete'} ${active}`}
                desc={`Please confirm to delete the following ${active}?`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirm(false)
                        }
                    },
                    {
                        name: 'Delete',
                        onClick: () => {
                            handleDelete()
                        }
                    }
                ]}

            >
                {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                }

            </Modal>

        </>
    )
}